import { render, staticRenderFns } from "./ConfigIcon.vue?vue&type=template&id=364f091a"
import script from "./ConfigIcon.vue?vue&type=script&lang=js"
export * from "./ConfigIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports